export interface UserBasic {
  id: number;
  login: string;
}

export function UserBasicFromJSON(json: Record<string, any>): UserBasic {
  return {
    id: json["id"],
    login: json["login"],
  };
}
